// extracted by mini-css-extract-plugin
module.exports = {"LoadingPageText":"LoadingPage_LoadingPageText__3QDru","Loader":"LoadingPage_Loader__1bmP8","load3":"LoadingPage_load3__2XtG-"};